/**
 * @generated SignedSource<<7c07773b9ada20dc0a247c62eb268275>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type taiPoFireTragedyEPaperCollectionQuery$variables = Record<PropertyKey, never>;
export type taiPoFireTragedyEPaperCollectionQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type taiPoFireTragedyEPaperCollectionQuery = {
  response: taiPoFireTragedyEPaperCollectionQuery$data;
  variables: taiPoFireTragedyEPaperCollectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "tai_po_fire_epaper"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"tai_po_fire_epaper\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "taiPoFireTragedyEPaperCollectionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "taiPoFireTragedyEPaperCollectionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cd864ffd0f2f215abe3b7bc10830e505",
    "id": null,
    "metadata": {},
    "name": "taiPoFireTragedyEPaperCollectionQuery",
    "operationKind": "query",
    "text": "query taiPoFireTragedyEPaperCollectionQuery {\n  appConfig(filter: {entityId: \"tai_po_fire_epaper\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "3322881090934a3b33eaec493f4f1f53";

export default node;
